import { WARNING_MINIMUM_DPI } from '@/guidetti/projectConstantes';
/**
 * Check if the image quality is good enough
 * @param params
 * @returns boolean - true if image is below 200dpi
 */
function imageQualityChecker(params: { width: number; height: number; scaleX: number; scaleY: number; dpiCheck: number }) {
    const { width, height, scaleX, scaleY, dpiCheck } = params;
    const qualityX = width / ((width * scaleX) / dpiCheck);
    const qualityY = height / ((height * scaleY) / dpiCheck);
    return qualityX < WARNING_MINIMUM_DPI || qualityY < WARNING_MINIMUM_DPI;
}

export { imageQualityChecker };
